var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Loader",style:(_vm.style)},[_c('svg',{attrs:{"viewBox":"0 0 32 32","width":"32","height":"32"}},[_c('circle',{staticClass:"Loader__spinner",attrs:{"cx":"16","cy":"16","r":"14","fill":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }